export default function MODAL_WIDTH(width, isCentered = false) {
  const widths = {
    xs: 'w-[480px]',
    small: 'w-[640px]',
    medium: 'w-[800px]',
    large: 'w-[1056px]',
    full: 'w-full xxl:max-w-[1920px]'
  };
  return isCentered ? widths['xs'] : widths[width];
}
